import { InjectionToken, inject } from '@angular/core';

import { ApiServiceExternal } from '@frontend/sports/common/api-utils';
import { ConnectionConfig } from '@frontend/sports/common/client-config-data-access';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';

import { ApiBaseSettingsProvider } from './api-settings.service';
import { BaseCdsApi, CdsApiOptions } from './cds-api.service';

export type BaseCdsApiFactory = (options: CdsApiOptions) => BaseCdsApi;

const cdsFactory =
    (
        apiServiceExternal: ApiServiceExternal,
        loggerFactory: LoggerFactory,
        connectionConfig: ConnectionConfig,
        apiSettings: ApiBaseSettingsProvider,
    ): BaseCdsApiFactory =>
    (options: CdsApiOptions) =>
        new BaseCdsApi(apiServiceExternal, loggerFactory, connectionConfig, apiSettings).configure(options);

// This needs to be provided in root as multiple root services access it
// Making it non-root causes issues in the Host-App setup for Sports
// Todo - SportsRefactor: This should be moved to a root service, no reason to use an injection token for it.
// It's not overriden anywhere, only this one instance exists.
export const CDS_API_FACTORY = new InjectionToken<BaseCdsApiFactory>('CDS_API_FACTORY', {
    providedIn: 'root',
    factory: () => {
        const apiServiceExternal = inject(ApiServiceExternal);
        const loggerFactory = inject(LoggerFactory);
        const connectionConfig = inject(ConnectionConfig);
        const apiSettings = inject(ApiBaseSettingsProvider);

        return cdsFactory(apiServiceExternal, loggerFactory, connectionConfig, apiSettings);
    },
});
